import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CadastroBensModalComponent } from './cadastro-bens-modal';

@Component({
  template: ``
})
export class CadastrarBensComponent implements OnDestroy {
  destroy = new Subject<any>();
  constructor(private route: ActivatedRoute,
    private router:Router,
    private modalService:NgbModal) {
      this.route.params.subscribe(
        params =>{
          //console.log/'PARAMETRO ===>',params);
          const modalRef = this.modalService.open(CadastroBensModalComponent, {
            size: 'lg',
            backdrop: 'static',
            centered:true
          });
          modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = params.id
          modalRef.result.then(() =>{
            this.router.navigate(['/cadastrarBem/',params.id]);
          }, reason => {
            this.router.navigateByUrl('/cadastrarBem');
        });
      });
     }
     ngOnDestroy() {
      this.destroy.next();
    }
}